<section>
  <form [formGroup]="form">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="user-dashboard-info-box">
            <div class="section-title-02 mb-4">
              <h4>Basic Information</h4>
            </div>
            <app-image-cropper
              buttonTitle = "Upload Logo"
              [shouldUploadFile]="true"
              (imageCropperEvent)="handleFileChangeEvent($event)"></app-image-cropper>
            <div class="form-row" *ngIf="uploadStatus">
              <p class="text-danger pl-3">{{uploadStatus}}</p>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Company Name*</label>
                <input type="text" class="form-control" formControlName="companyName"
                  [class.is-invalid]="(form.controls['companyName']?.errors || form.controls['companyName']?.errors?.required)">
              </div>
              <div class="form-group col-md-6">
                <label>Email*</label>
                <input type="email" class="form-control" formControlName="email"
                  [class.is-invalid]="(form.controls['email']?.errors || form.controls['email']?.errors?.required)">
              </div>
              <div class="form-group col-md-6">
                <label>First Name*</label>
                <input type="text" class="form-control" formControlName="firstName"
                  [class.is-invalid]="(form.controls['firstName']?.errors || form.controls['firstName']?.errors?.required)">
              </div>
              <div class="form-group col-md-6">
                <label>Last Name*</label>
                <input type="text" class="form-control" formControlName="lastName"
                  [class.is-invalid]="(form.controls['lastName']?.errors || form.controls['lastName']?.errors?.required)">
              </div>
              <div class="form-group col-md-6">
                <label>Phone*</label>
                <input type="text" class="form-control" formControlName="phone"
                  [class.is-invalid]="(form.controls['phone']?.errors || form.controls['phone']?.errors?.required)">
              </div>
              <div class="form-group col-md-6 select-border">
                <label>Sector</label>
                <select class="form-control basic-select" formControlName="sector" [class.is-invalid]="form.controls['sector'].touched && (form.controls['sector']?.errors || form.controls['sector']?.errors?.required)">
                  <option *ngFor="let sector of lookupStore.sectors | async" [ngValue]="sector.id">{{sector.name}}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label>Website</label>
                <input type="text" class="form-control" formControlName="website" placeholder="www.example.com"
                  [class.is-invalid]="form.controls['website'].touched && form.controls['website']?.errors">
              </div>
              <div class="form-group col-md-12 mb-0">
                <label>Description</label>
                <textarea class="form-control" rows="5" formControlName="description" maxlength="1000"
                  placeholder="Please give a brief description of your business."></textarea>
              </div>
            </div>
          </div>
          <div class="user-dashboard-info-box">
            <div class="section-title-02 mb-3">
              <h4>Social Links</h4>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Facebook</label>
                <input type="text" class="form-control" formControlName="facebook"
                  placeholder="https://www.facebook.com/username"
                  [class.is-invalid]="form.controls['facebook'].touched && form.controls['facebook']?.errors">
              </div>
              <div class="form-group col-md-6">
                <label>Twitter</label>
                <input type="email" class="form-control" formControlName="twitter"
                  placeholder="https://twitter.com/username"
                  [class.is-invalid]="form.controls['twitter'].touched && form.controls['twitter']?.errors">
              </div>
              <div class="form-group col-md-12 mb-0">
                <label>Linkedin</label>
                <input type="text" class="form-control" formControlName="linkedin"
                  placeholder="https://www.linkedin.com/in/username"
                  [class.is-invalid]="form.controls['linkedin'].touched && form.controls['linkedin']?.errors">
              </div>
            </div>
          </div>
          <div class="user-dashboard-info-box">
            <div class="form-group mb-0">
              <h4 class="mb-3">Location</h4>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>City *</label>
                  <input type="text" class="form-control" formControlName="city"
                    [class.is-invalid]="(form.controls['city']?.errors || form.controls['city']?.errors?.required)">
                </div>
                <div class="form-group col-md-6">
                  <label>Country *</label>
                  <select class="form-control basic-select" formControlName="country" [class.is-invalid]="(form.controls['country']?.errors || form.controls['country']?.errors?.required)">
                    <option *ngFor="let country of lookupStore.countries | async" [ngValue]="country.id">{{country.name}}
                    </option>
                  </select>
                </div>
                <div class="form-group mb-0 col-md-12">
                  <label>Address *</label>
                  <input type="text" class="form-control" formControlName="address"
                  [class.is-invalid]="(form.controls['address']?.errors || form.controls['address']?.errors?.required)">
                </div>
              </div>
            </div>
          </div>
          <a class="btn btn-md btn-primary" [routerLink]="" (click)="saveProfile()">Save</a>
        </div>
      </div>
    </div>
  </form>
</section>
